<template>
    <div class="wlx-user-manager-wrapper">
        <div class="add-partner-enterprise-head clearfix">
            <div class="top-page-top fl">
                <span class="sp-top-text">考试文件管理</span>
            </div>
            <div class="fr btn-right">
                <el-form :inline="true" size="small">
                    <el-form-item>
                        <el-input v-model="userName" placeholder="请输入文件名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" @click="addSchool">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>

        <el-table :data="examFiel">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column prop="name" label="文件名称"></el-table-column>
            <el-table-column prop="dateCreated" label="创建时间"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" content="修改" placement="top">
                        <el-button icon="el-icon-edit" size="mini" type="primary" @click="editSchool(scope.row)"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top">
                        <el-button icon="el-icon-delete" size="mini" type="danger" @click="deleteSchool(scope.row.id)"></el-button>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>

        <div class="u-page-con">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="onPageChangeHandler"
                :current-page="page"
                :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount"
                v-show="totalCount > 0"
                style="text-align: center;"
            ></el-pagination>
        </div> 

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" append-to-body width="50%">
            <el-form ref="ruleForm" label-width="160px">
                <el-form-item label="文件名称" prop="title">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="文件" prop="title">
                    <!-- <el-input v-model="form.name"></el-input> -->
                    <applyFileUpload
                        :url="urlAliyunOSS"
                        :files="files"
                        :fileLists="files"
                        @done="onAllFilesUploadb"
                        class="apply-file-upload"
                    ></applyFileUpload>



                </el-form-item>
            </el-form>


            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="addOrEditSchool()">确 定</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import applyFileUpload from "components/uploads/uploadEnclosure.vue";
export default {
    data() {
        return {
            name:"",
            page: 1,
            pageSize: 10,
            totalCount: 0,
            siteList: [],
            dialogVisible: false,
            userName: "",
            displayName: "",
            newPassword: "",
            id: "",
            schoolId: "",
            examFiel:[],
            dialogTitle:"",
            urlAliyunOSS: "/api/XOrg/AssociationIndex/getSign",
            files:[],
            form:{
                id:"",
                name:"",
                filebIds:[]
            },
            provinceList:[],
            cityList:[]
        };
    },
    components: {
        applyFileUpload
    },
    created() {
        this.getExamFile();
    },
    props:{
        certificateId:{
            default:"",
            type:String
        }
    },
    methods: {
        search(){
            this.page = 1;
            this.getExamFile();
        },
        onAllFilesUploadb(files) {
            this.filebIds = [];
            this.form.filebIds = files;
        },
        getExamFile(){
            var that = this;
            this.$http.post("/api/XOrg/ExamFile/getExamFile",{
                certificateId: this.certificateId,
                type: 0,
                page:this.page,
                pageSize:this.pageSize
            }).then(function(rst) {
                if (rst.code > 0) {
                    that.examFiel = rst.list;
                    that.page = rst.pagination.pageIndex;
                    that.pageSize = rst.pagination.pageSize;
                    that.totalCount = rst.pagination.totalCount;
                }
            });

        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getExamFile();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getExamFile();
        },
        addSchool(){
            this.dialogTitle = "添加";
            this.form.id = "";
            this.form.name = "";
            this.form.filebIds = [];
            this.dialogVisible = true;
        },
        editSchool(row){
            this.dialogTitle = "修改";
            this.form.id = row.id;
            this.form.name = row.name;
            this.form.filebIds = [];
            this.files = [];
            this.files.push({
                id:row.docId,
                docPrviewUrl:row.docPrviewUrl,
                name:row.docTitle,
                url:row.docUrl,
                status:2
            });
            this.dialogVisible = true;
        },
        addOrEditSchool(){
            debugger;
            if(this.form.filebIds.length==0){
                this.$message.warning("请上传文件！");
                return;
            }
            this.$http
            .post("/api/XOrg/ExamFile/addOrEditExamFile", {
                examFileId:  this.form.id,
                docId:this.form.filebIds[0],
                name:this.form.name,
                certificateId:this.certificateId,
                type:0
            })
            .then((rst) => {
                if (rst.code > 0) {
                    this.$message.success(rst.msg);
                    this.getExamFile();
                    this.dialogVisible = false;
                } else {
                    this.$message.warning(rst.msg);
                }
            });
        },
        deleteSchool(id) {
            this.$confirm("此操作将删除所选文件, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$http
                        .post("/api/XOrg/ExamFile/deleteIds", {
                            ids: id,
                        })
                        .then((rst) => {
                            if (rst.code > 0) {
                                this.$message.success(rst.msg);
                                this.getExamFile();
                            } else {
                                this.$message.warning(rst.msg);
                            }
                        });
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        }
    },
};
</script>
<style lang="scss">
.wlx-user-manager-wrapper {
    background: #fff;
    padding-bottom: 20px;
    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;
        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }
        .delete-banner-btn {
            margin-right: 62px;
        }
        .top-page-top{
            border: none;
        }
    }
    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }
    .el-table thead{
        color: #05243D;
    }
    .btn-right{
        margin-right: 30px;
        margin-top: 14px;
    }
}
</style>
